export default __webpack_public_path__ + "static/albumTelevision-7b7152b636b4ae0ee87fe74bdb3846bd.svg";